// extracted by mini-css-extract-plugin
export default {"Watermark":"TLvgegURIoxUaK88v6aW"};